import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { page as pageIndex, screenSize } from '../../globals'
import { updateData } from '../../store/reducers/updateData'
import DropdownField from '../FormComponents/DropdownField/DropdownField'
import TabsWrapper from '../ManagementTools/components/TabsWrapper'
import STSComponent from '../STSComponent/STSComponent'
import DeletedRecordLine from './components/DeletedRecordLine'
import RestoreButtonWithRecords from './components/RestoreButtonWithRecords'
import { constants } from './constants'
import './css/ManagementDeletedRecordsArchive.scss'

class DeletedRecordsArchive extends STSComponent {
  returnTabContent = (type) => {
    const { trackData, updateData } = this.props
    const classNames = constants.titles.map(item => item.className)
    return <div className="deleted-records-body-wrap custom-scroll">
      <RestoreButtonWithRecords records={constants.data.length} />
      {window.innerWidth <= screenSize.extraSmall
        ? null
        : <div className="deleted-records-table-header">{this.returnTableTitle()}</div>}
      {constants.data.map((item, i) => {
        return <DeletedRecordLine
          id={i}
          key={i}
          itemData={item}
          trackData={trackData}
          classNames={classNames}
          updateData={updateData}
        />
      })}
    </div>
  }

  returnTableTitle = () => {
    return constants.titles.map((item, i) => {
      return <div key={i} className={`deleted-records-cell titles ${item.className}`}>
        {item.title}
      </div>
    })
  }

  render () {
    const { trackData, updateData } = this.props
    return <div className="deleted-records-wrapper">
      <div className="deleted-records-year-wrap">
        <DropdownField
          id="archivedYear"
          location={{ page: pageIndex.dashboard, field: 'archivedYear', section: 'deletedRecords' }}
          options={[]}
          value={trackData.archivedYear.radio.archivedYear}
          placeholder="Archived Year"
          updateData={updateData}
        />
      </div>
      <TabsWrapper
        legis={this.returnTabContent('legis')}
        regs={this.returnTabContent('regs')}
        local={this.returnTabContent('local')}
      />
    </div>
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func
  }
}

export default connect(state => ({
  trackData: state.deletedRecordsArchive.formDataValue.D
}), {
  updateData
})(DeletedRecordsArchive)



// WEBPACK FOOTER //
// ./src/components/ManagementDeletedRecordsArchive/ManagementDeletedRecordsArchive.js